import classNames from 'classnames';
import React from 'react';

import {ElementMouseEvent} from 'util/Types';

interface PositionedPopoverProps {
  children?: React.ReactNode;
  className?: string;
  top: number;
  left: number;
  width: number;
  showArrow: boolean;
}

export default class PositionedPopover extends React.Component<PositionedPopoverProps> {
  static defaultProps = {
    width: 250,
    showArrow: true,
  };

  static mouseDownInPopover(e: ElementMouseEvent): boolean {
    return e.isDefaultPrevented();
  }

  private handleMouseDown = (e: ElementMouseEvent): void => {
    e.preventDefault();
  };

  render(): JSX.Element {
    return (
      <div
        className={classNames('positionedPopover', this.props.className, {
          'positionedPopover--noArrow': !this.props.showArrow,
        })}
        style={{top: this.props.top, left: this.props.left, width: this.props.width}}
        onMouseDown={this.handleMouseDown}
      >
        {this.props.showArrow && <div className="positionedPopover-arrow" />}
        {this.props.children}
      </div>
    );
  }
}
